import store from '@/utils/store'
export const columns = (vm) => {
    return [
        {
            type: 'index',
            minWidth: 60,
            label: '序号',
            align: 'center',
            headerAlign: 'center',
        },

        {
            label: '消息ID',
            prop: 'uuid',
            align: 'left',
            headerAlign: 'left',
            minWidth: 210
        },
        {
            label: '序列号/IMEI',
            prop: 'deviceId',
            align: 'left',
            headerAlign: 'left',
            minWidth: 260
        },
        {
            label: '上报时间',
            prop: 'reportTime',
            align: 'left',
            headerAlign: 'left',
            minWidth: 150
        },
        {
            label:'hexData',
            prop:'hexData',
            align:'left',
            headerAlign:'center',
            width:300,
           
        },
        {
            label: '设备IP',
            prop: 'deviceHostName',
            align: 'left',
            headerAlign: 'left',
            minWidth: 120
        },

		{
		    label: '接收/处理时间',
		    align: 'left',
		    headerAlign: 'left',
		    width:140,
			render: (h, params) => {
			   return h('span',{},params.row.reportTime+"  "+params.row.processTime)
			}
		},
        {
            label: '备注',
            prop: 'remark',
            align: 'left',
            headerAlign: 'left'
        },
        {
			label: '操作',
			// fixed: 'right',
			align: "center",
			headerAlign: "center",
			minWidth: 120,
			render: (h, params) => {

				const warehousBtn = (h) => {
					return h('el-button', {
						props: {
							type: 'text',
						},
						style: {
							
						},
						on: {
							click: () => {
								vm.lookBtn(params.row);
							}
						}
					},"查看")
				}
				
				const buttons = [];
				buttons.push(warehousBtn(h));
				
				return h('span', {}, buttons);
			}
		}
       
    ]
}